
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0dON9q0AmdrKUgLvdD9ZEh4dLa2ERs8stl0UPkq6e5EMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexg3jTHPPzm_icTwohzPdWeTVdpTRebhHLdgWZXRR89VIMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchn6I6WagD_EeRDw55FxIaiTQBhYQol5yDOj3cjkVXyZQMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexmocOaDZ218tsptTkqz0hUs2NLVduSH8KMdMxy4W5huoMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93V8L07rgp2t9ep_UMi4PnkmTxwqowpf6kf42LbLwk5ioMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexQiGHl12bj_SvAC7AkrwXjQBhSRZCTzSEXb4eKO6J8SoMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93HXvSRbU0ZHkCPaoK1b2NBedIOOfxKghQH_P_K_45XP4xkMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexnsnrrw9IfXo9YyD7GE8MD6SixdyhNN5n3_JuYYm1AqkMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ZLf8SJkn6x8PzzcrlNcMX0_45oL96nYCkUy12JDrlRS6YMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexn4eMwC1wE8TODbDMA8_45MTUcS4RbEM4pbBE_F_457rVwDcMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexStZmC9P7JA3OSzjP8PB_45W85eeDHtIqhzj0dG8hoEaukMeta } from "/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexQiGHl12bj_SvAC7AkrwXjQBhSRZCTzSEXb4eKO6J8SoMeta || {},
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexnsnrrw9IfXo9YyD7GE8MD6SixdyhNN5n3_JuYYm1AqkMeta || {},
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexn4eMwC1wE8TODbDMA8_45MTUcS4RbEM4pbBE_F_457rVwDcMeta || {},
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexStZmC9P7JA3OSzjP8PB_45W85eeDHtIqhzj0dG8hoEaukMeta || {},
    component: () => import("/codebuild/output/src898902842/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]